export default [1, 0, 0, 2, 2];